import store from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('setIsSaving', function setIsValidatingDomain(newValue) {
    store.isValidatingDomain = newValue;
});
//# sourceMappingURL=setIsValidatingDomain.js.map